export default __webpack_public_path__ + "static/media/Bar - Browser.b8a2e6c8.png";